import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { DetailColumn, selectableColumns, AssociatedPositions } from './columns'

export const useSelectedColumns = (): ColumnDef<
  AssociatedPositions[number]
>[] => {
  return useMemo(() => {
    return [
      ...selectableColumns.map((column) => column.columnDef),
      DetailColumn,
    ]
  }, [])
}
